module.exports = __webpack_public_path__ + "static/media/all-feedback.68e54645.png";